import { render, staticRenderFns } from "./ResearchSubSection.vue?vue&type=template&id=4bd79de8&scoped=true"
import script from "./ResearchSubSection.vue?vue&type=script&lang=js"
export * from "./ResearchSubSection.vue?vue&type=script&lang=js"
import style0 from "./ResearchSubSection.vue?vue&type=style&index=0&id=4bd79de8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd79de8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bd79de8')) {
      api.createRecord('4bd79de8', component.options)
    } else {
      api.reload('4bd79de8', component.options)
    }
    module.hot.accept("./ResearchSubSection.vue?vue&type=template&id=4bd79de8&scoped=true", function () {
      api.rerender('4bd79de8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchSubSection.vue"
export default component.exports